// Put stuff in here that is widely used across the site.
//
// Features that are used only on a few pages, such as most
// view components, should be imported into individual packs.

// In the near future:
//  - DONE remove app/assets/javascript/application.js
//  - TODO rename utils.js into application.js and fix all stylesheet_pack_tag :utils call

import { createElement } from 'react'
import ReactDOM from 'react-dom'
import {mountOnId, mountOnDataBehavior} from 'shared'
import shortAndSweet from 'short-and-sweet'
import autosize from 'autosize'

import 'tailwindcss/base'
import 'stylesheets/application'
import 'tailwindcss/components'
// <List of all css betterplace-components (bpc) that use Tailwind `@apply`. Sorted A-Z. >
import 'stylesheets/betterplace-components/notice'
import 'stylesheets/betterplace-components/quickinfo'
import 'stylesheets/betterplace-components/table'
import 'stylesheets/betterplace-components/whitelinks'
import 'stylesheets/tailwind-test'
// </List>
import 'tailwindcss/utilities'
import 'stylesheets/betterplace-utilities/betterplace_utilities'

import 'whatwg-fetch'

import {
  CookieBanner,
  CookieBannerLink,
  PlatformAdminUI,
  RandomProjectHotkey,
  gaScrollTracking,
  SubscriptionToggle,
  initializeCollapse,
} from 'utils'

import {
  CentsInput,
  CopyComponent,
  CounterWidget,
  ModalLink,
  PasswordReveal,
  PasswordStrengthMeter,
  PopoverIcon,
  PopoverText,
  TimeAgo,
  TimerWidget,
  addBrowserAnnotations,
  Swiper,
} from 'shared'

import {
  LoginLink,
  NavigationSearch,
  ProjectSwiper,
  LottieAnimation,
  VideoPlayer,
  AccordeonItem,
} from 'modules'

import Rails from "@rails/ujs"
Rails.start()

document.addEventListener("DOMContentLoaded", () => {
  new PlatformAdminUI()
  new RandomProjectHotkey()
  global.PlatformAdminUI = PlatformAdminUI
  addBrowserAnnotations()

  shortAndSweet("[maxlength]:not([data-maxlength-counter='false'])", {
    counterClassName: 'module-text-counter',
    counterLabel: '{length} / {maxlength}',
    append: (el, counter) => { el.parentNode.insertBefore(counter, el.nextSibling) }
  })

  const centsInput = document.querySelectorAll('[data-behavior="cents-input"]')
  Array.from(centsInput).forEach(function (el) {
    const tag = createElement(CentsInput, {control: el.nextSibling, initialValue: el.dataset.initialValue})
    ReactDOM.render(tag, el)
  })

  autosize(document.querySelectorAll('textarea'))

  mountOnId(CookieBanner, 'cookie-banner')
  mountOnId(LoginLink, 'header-login-mountpoint')
  mountOnId(NavigationSearch, 'header-search-mountpoint')
  mountOnDataBehavior(CookieBannerLink, 'cookie-banner-link')
  mountOnDataBehavior(TimeAgo, 'time_ago')
  mountOnDataBehavior(CounterWidget, 'counter-widget')
  mountOnDataBehavior(TimerWidget, 'timer-widget')
  mountOnDataBehavior(PasswordReveal, 'password_reveal')
  mountOnDataBehavior(PasswordStrengthMeter, 'password_strength')
  mountOnDataBehavior(SubscriptionToggle, 'subscription-toggle')
  mountOnDataBehavior(CopyComponent, 'copy-component')
  mountOnDataBehavior(PopoverIcon, 'popover-icon')
  mountOnDataBehavior(PopoverText, 'popover-text')
  mountOnDataBehavior(ModalLink, 'modal-link')
  mountOnDataBehavior(ProjectSwiper, 'project-swiper')
  mountOnDataBehavior(Swiper, 'swiper')
  mountOnDataBehavior(LottieAnimation, 'lottie-animation')
  mountOnDataBehavior(VideoPlayer, 'video-player')
  mountOnDataBehavior(AccordeonItem, 'accordeon-item')

  mountLoadMoreDonationsLink()

  Array.from(document.querySelectorAll('[data-behavior="copy-content"]')).forEach(function (el) {
    el.addEventListener('click', () => {
      el.focus()
      el.select()
    })
  })

  Array.from(document.querySelectorAll('[data-behavior="radio-details-group"]')).forEach(function (el) {
    const radios = Array.from(el.querySelectorAll('input[type=radio]'))
    radios.forEach(radio => {
      radio.parentNode.addEventListener('click', () => {
        radios.forEach(r => r.parentNode.classList.remove('checked'))
        radio.parentNode.classList.add('checked')
      })
    })
  })

  // this will not affect tax exemptions, quittances, and other dropzone uploads
  Array.from(document.querySelectorAll('input[type="file"]')).forEach(function (el) {
    el.addEventListener('change', event => {
      const maxMB = 10
      const maxBytes = maxMB * 1024 * 1024
      const input = event.currentTarget
      if (input.files && input.files[0] && input.files[0].size > maxBytes) {
        alert(I18n.t('errors.max_file_size'))
        input.value = null
      }
    })
  })

  initializeCollapse()
})

document.addEventListener('scroll', gaScrollTracking)

// Quick fix to get donation list working again
const mountLoadMoreDonationsLink = () => {
  const nodes = document.querySelectorAll(`[data-behavior=load-more-donations-link]`)
  Array.from(nodes).forEach(node => {
    node.addEventListener('click', (event) => {
      event.preventDefault()
      fetch(node.href).then(response => response.text()).then(html => {
        node.parentNode.innerHTML = html
        mountOnDataBehavior(TimeAgo, 'time_ago')
        mountLoadMoreDonationsLink()
        PlatformAdminUI()
      })
    })
  })
}
